import * as React from 'react'
function SvgCurrencyDollar(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22 18.4v-6.2c1.2.4 2 1.6 2 2.8 0 1.2.8 2 2 2s2-.8 2-2c0-3.6-2.6-6.4-6-6.8V6c0-1.2-.8-2-2-2s-2 .8-2 2v2.2c-3.4.4-6 3.2-6 6.8 0 4.2 3.2 5.8 6 6.6v6.2c-1.2-.4-2-1.6-2-2.8 0-1.2-.8-2-2-2s-2 .8-2 2c0 3.6 2.6 6.4 6 6.8V34c0 1.2.8 2 2 2s2-.8 2-2v-2.2c3.4-.4 6-3.4 6-6.8 0-4.2-3.2-5.8-6-6.6zM16 15c0-1.4.8-2.4 2-2.8v5.2c-1.4-.6-2-1.2-2-2.4zm6 12.8v-5.2c1.4.6 2 1.2 2 2.4 0 1.4-.8 2.4-2 2.8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyDollar
